<!-- ── Onglets encore dépendants de l'ancien front ───────────────────────────
     Rendus dans <app-legacy-host> (restaure les styles .old-theme) et seulement
     une fois que UtilisateurService pointe sur le site de l'URL. Voir blast-tabs.ts. -->
@if (isLegacyTab()) {
  @if (legacy.ready()) {
    <app-legacy-host>
      @if (activeTabId() === 'load-haul') {
        <app-legacy-blast-load-haul [blastId]="blastId()" />
      }
      @if (activeTabId() === 'fleet') {
        <app-legacy-blast-fleet [blastId]="blastId()" />
      }
    </app-legacy-host>
  }
}

<!-- ── Écran BLAST — onglets refondus ─────────────────────────────────────── -->
@if (activeTabId() === 'dashboard') {
  <app-blast-dashboard [blastId]="blastId()" />
}
@if (activeTabId() === 'files') {
  <app-blast-files [tirId]="blastId()" [apiEndPoint]="'WorkflowSteps'" />
}
@if (activeTabId() === 'history') {
  <app-blast-job-history [tirId]="blastId()" />
}
@if (activeTabId() === 'kpi') {
  <app-blast-kpi
    [tabConfigSaisie]="configSaisieSite()"
    [tabDonneesAnalyse]="donneesAnalyseBlast()"
    [donneesChargees]="initAnalyseFaite()"
    [estProjet]="false"
    [estTir]="true"
    [tirId]="blastId()"
    [kpiIsVerified]="kpiIsVerified()"
    (verifyToggled)="onKpiVerifiedChange($event)"
    (rechargerDonnees)="chargerDonneesAnalyse()"
    class="w-100">
  </app-blast-kpi>
}
@if (activeTabId() === 'holes') {
  <app-blast-holes [blastId]="blastId()" class="w-100" />
}
@if (activeTabId() === 'fragmentation') {
  <app-fragmentation [blastId]="blastId()" />
}
@if (activeTabId() === 'vibrations') {
  <app-blast-vibration [blastId]="blastId()" class="w-100" />
}
@if (activeTabId() === 'environment') {
  <app-blast-environment [tirId]="blastId()" [blast]="blast()" class="w-100"></app-blast-environment>
}
@if (activeTabId() === 'feedback') {
  <app-customer-feedback class="w-100"
    [tirId]="blastId()"
    [regionId]="regionId()"
    [surveyResponses]="customerSurveyResponses()"
    [surveyJsonForm]="surveyJsonForm"
    [hasWritePermission]="hasWriteCustomerSurvey()"
    (rechargerDonnees)="chargerCustomerSurveyResponses()">
  </app-customer-feedback>
}
@if (activeTabId() === 'supplier-feedback') {
  <app-supplier-feedback class="w-100"
    [tirId]="blastId()"
    [regionId]="regionId()"
    [surveyResponses]="supplierSurveyResponses()"
    [surveyJsonForm]="surveyJsonForm"
    [hasWritePermission]="hasWriteSupplierSurvey()"
    (rechargerDonnees)="chargerSupplierSurveyResponses()">
  </app-supplier-feedback>
}
